<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- MSDS -->
    <msds-module :readonly="board.readonly" v-model="form.msds" title="MSDS(물질안전보건자료)" :is-print="isPrint" />

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>

import FieldSelectModule from '@/views/modules/FieldSelectModule.vue'
import FileUploadModule from '@/views/modules/FileUploadModule.vue'
import MsdsModule from '@/views/boards/single-page/397/MsdsModule.vue'

export default {
  components: {
    MsdsModule,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {}
    },
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        msds: [],
        fileList: [],
      },
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
